export default {"src":"/_next/static/media/arrow-icon.d6d1c2ff.svg","height":17,"width":15,"blurWidth":0,"blurHeight":0};